import useRetrieveAllChildrenDataOutputs from '@/hooks/api/steps/useRetrieveAllChildrenDataOutputs.ts';
import { useMemo } from 'react';
import { makeDynamicOptionValue } from '@/pages/Editor/components/SharedFields/DataInputSelector/hooks/useDataInputOptions.ts';

export type ChildDataOutputOption = {
  value: string;
  label: string;
  stepId: string;
};

type returnType = {
  outputs: ChildDataOutputOption[];
  isPending: boolean;
};

const useRetrieveChildrenDataOutputs = (stepId: string): returnType => {
  const { data: allDataOutputs, isPending } = useRetrieveAllChildrenDataOutputs();

  const stepDataOutputs = useMemo(() => {
    return (
      Object.entries(allDataOutputs?.step_data_outputs || {}).find(
        (step) => step[0] === stepId,
      )?.[1] || []
    ).map((dataOutput) => ({
      value: makeDynamicOptionValue(dataOutput.step_id, dataOutput.output_id),
      label: dataOutput.output_name
        ? `${dataOutput.step_name} - ${dataOutput.output_name}`
        : dataOutput.step_name,
      stepId: dataOutput.step_id,
    }));
  }, [allDataOutputs?.step_data_outputs, stepId]);

  return { outputs: stepDataOutputs, isPending };
};

export default useRetrieveChildrenDataOutputs;
